const ShortenText = (text, characterLimit) => {
    const limit = characterLimit ? characterLimit : 120
    const output = text.slice(0, limit) + (text.length > limit ? "..." : "")
    return output
}

export default ShortenText